import { Component, OnInit, OnDestroy, NgZone } from '@angular/core';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { I18nService } from './core/i18n/i18n.service';
import { environment } from '@env/environment';

declare const window: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'md-online';

  routerSubject: Subject<string> = new Subject<string>();
  languageSubject: Subject<string> = new Subject<string>();

  constructor(
    private router: Router,
    private ngZone: NgZone,
    private translateService: TranslateService,
    private i18nService: I18nService) {
    // Assign the observable to the window object, so that we can call it from outside
    //window.routerSubject = this.routerSubject;
    window.languageSubject = this.languageSubject;    
  }

  ngOnInit() {
    /*
    this.routerSubject.subscribe((url: string) => {
      // Programmatically navigate whenever a new url gets emitted.
      this.ngZone.run(() => {
        this.router.navigate([`/${url}`]);
      });
    });
    */

    this.languageSubject.subscribe((lang: string) => {
      this.i18nService.language = lang;
      // console.log('lang:', lang, 'environment.defaultLanguage:', environment.defaultLanguage);
    });
  }

  ngOnDestroy() {
    //this.routerSubject.unsubscribe();
    this.languageSubject.unsubscribe();
  }
}